export const initialize = (applicationInstance) => {
  const service = applicationInstance.lookup('service:element-callback');
  window.elementCallbackService = (elementId) => service.callbacks.get(elementId)?.();
};

export default {
  initialize,
};
